import { Operator } from 'config'

export interface ILoanConditionVisibilityOption {
  fieldOrigin: ILoanStructureConditionFieldOrigin
  fieldKey: string
  value: string | number | boolean
  operator?: Operator
}

export interface ILoanStructureCondition {
  visibleLogic: ILoanConditionVisibilityOption[][]
  value: Array<number>
  detectChange: boolean
  tasks?: Array<any>
}

export enum ILoanStructureConditionFieldOrigin {
  LoanStructure = 'LoanStructure',
  BorrowerInformation = 'BorrowerInformation',
  PropertyInformation = 'PropertyInformation',
  AssetLiability = 'AssetLiability',
  TrackRecord = 'TrackRecord',
  DeclarationsHMDA = 'DeclarationsHMDA',
}

export const ILoanStructureConditionFieldOriginOptions: Record<ILoanStructureConditionFieldOrigin, string> = {
  [ILoanStructureConditionFieldOrigin.LoanStructure]: 'Loan Structure',
  [ILoanStructureConditionFieldOrigin.BorrowerInformation]: 'Borrower Information',
  [ILoanStructureConditionFieldOrigin.PropertyInformation]: 'Loan and Property Information',
  [ILoanStructureConditionFieldOrigin.AssetLiability]: 'Asset & Liability',
  [ILoanStructureConditionFieldOrigin.TrackRecord]: 'Track Record',
  [ILoanStructureConditionFieldOrigin.DeclarationsHMDA]: 'Declarations & HMDA',
}
